import React, { useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import { connect } from 'react-redux';
// import { useHistory } from "react-router-dom";
import axios from 'axios';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import moment from 'moment';
// require('dotenv').config()
// import N from '@material-ui/icons/Notifications';
import Badge from '@material-ui/core/Badge';
// import EditIcon from "@material-ui/icons/Edit"
// import styles from "assets/css/argon-dashboard-react.css"
import Avatar from '@material-ui/core/Avatar';
// import IconButton from '@material-ui/core/IconButton';
// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
// import { handleTheme, handleText } from 'pages/redux/actions';
import { Collapse, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, Media, NavbarBrand, Navbar, NavItem,Button, NavLink, Nav, Container, Row, Col,} from "reactstrap";

// const options = [
//   { key: 'dark', label: 'Dark' },
//   { key: 'white', label: 'Light' },
//   { key: 'darkpurple', label: 'Dark Purple' },
// ];

const Sidebar = (props) => {
  const { routes, logo } = props;
  // console.log('hello')
  // console.log(props.theme)
  // console.log(props.text)
  // console.log(props.noti)
  var atype = 'Student Account'
  if (props.adminValue === true) {
    atype = 'Faculty Account'
  }
  if (props.superValue === true) {
    atype = 'Super Admin Account'
  }

  if (props.display === 'xsmall') {
    document.body.style.zoom = 0.7
  }
  else if (props.display === 'small') {
    document.body.style.zoom = 0.85
  }
  else if (props.display === 'xlarge') {
    document.body.style.zoom = 1.3
  }
  else if (props.display === 'large') {
    document.body.style.zoom = 1.15
  }
  else {
    document.body.style.zoom = 1
  }
  // console.log(props.noti === undefined ? 'yes': props.noti.length)
  // const dispatch = useDispatch();
  const [sendingdata, setSendingdata] = React.useState('');
  const [namef, setNamef] = React.useState('');
  const [tt, settt] = React.useState('');
  const [open, setOpen] = React.useState(false);
  // const [open2, setOpen2] = React.useState(false);
  const [bgImage, setbgImage] = React.useState(logo);
  var nb = props.fullname.substring(0, 1)
  const fetchData = React.useCallback(() => {
    axios.get(process.env.REACT_APP_DOMAIN + "/profile", { 'headers': { 'Authorization': 'Token ' + props.token } })
      .then((response) => {
        if (response.data.photo != null) {
          var phurl = process.env.REACT_APP_DOMAIN + '' + response.data.photo;
          // console.log(phurl)
          setbgImage(phurl);
        }
        setNamef(nb)
      })
      .catch((error) => {
        setSendingdata('Something went wrong, Please Try Again')
        settt('error')
        setOpen(true);
        setNamef(nb)
      })
  }, [ nb, props.token])
  React.useEffect(() => {
    fetchData()
  }, [fetchData])

  // const [anchorEl, setAnchorEl] = React.useState < null | HTMLElement > (null);
  // let [anchorEl, setAnchorEl] = React.useState();
  // const open2 = Boolean(anchorEl);



  const handleClose = (event, reason) => {
    setOpen(false);
  };


  const [collapseOpen, setCollapseOpen] = useState();
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.path !== "/add-poster" && prop.path !== "/edit/:id" && prop.path !== "/event/:id" && prop.path !== "/add-event" && prop.path !== "/finished-events" && prop.path !== "/published-events" && prop.path !== "/registered-events" && prop.path !== "/add-pre-event" && prop.path !== "/user-profile" && prop.path !== "/profile/:id" && prop.path !== "/message/:id" )  //bolcks admin hidden pages
      {
      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
            activeClassName={"textbg-"+props.theme}
            className={"texts-"+props.theme}
          >
            <i className={prop.icon + " texts-" + props.theme} activeClassName={"textbg-" + props.text}/>
            <p className={'m-0 mt-1 except-font texts-'+props.theme}>{prop.name}</p>
          </NavLink>
        </NavItem>
      );
      }
      return(null)
    });
  };

  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }
  return (
    <Navbar
      className={"navbar-vertical br-light-" + props.theme +" fixed-left navbar-light sbg-"+props.theme+' bg-yellowc'}
      expand="md"
      id="sidenav-main"
    >
      <Container fluid className="bg-orangec cus-navbar">
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          {/* <span className={"navbar-toggler-icon texts-" + props.theme} /> */}
          <i className={"ni ni-bullet-list-67 texts-" + props.theme}></i>
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0 bg-yellowc" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
              style={{marginTop: '20px',height: '100px !important',marginLeft: ''}}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none bg-cyanc pro-items">
          <UncontrolledDropdown nav>
            <DropdownToggle className="pr-0" nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm" style={{ backgroundColor: 'transparent' }}>
                  <Badge badgeContent={props.noti === undefined ? 0 : props.noti.length} color="primary">
                    <i className={"ni ni-bell-55 textb-" + props.theme}></i>
                  </Badge>
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className={"dropdown-menu-arrow pb-0 lg-width front bg-front cardbg-" + props.theme} right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className={"text-overflow m-0 texts-" + props.theme}>You have {props.noti === undefined ? 0 : props.noti.length} Notifications</h6>
              </DropdownItem>
              {(props.noti !== undefined ?
                props.noti.map(function (noti, index) {
                  return (
                    <Button to={noti.link === null ? '#' : noti.link} tag={Link} onClick={() => { axios.get(process.env.REACT_APP_DOMAIN + "/markone=" + noti.id, { 'headers': { 'Authorization': 'Token ' + props.token } }); props.noti.splice(index, 1) }} className={"text-left br-0 noti noti-" + noti.type} color='link' >
                      <div className="full-width"><p className={'m-0 text-dark noti-para textsp-' + props.theme} >{noti.body}</p></div>
                      <div className="full-width text-right"><p className={'m-0 text-dark noti-para2 textsp-' + props.theme} >{moment(noti.pdate).fromNow()}</p></div>
                    </Button>
                    // <DropdownItem className="noti-act" to={"user-profile"} tag={Link}>
                    //   <span className={"texts-" + props.theme+' noti-'+noti.type}>{noti.body}</span>
                    // </DropdownItem>
                  )
                })
                :
                null
              )}
              {(props.noti === undefined ?
                <DropdownItem tag="div" disabled >
                  <p className={'m-0 text-dark noti-para textsp-' + props.theme} >No New Notifications U</p>
                </DropdownItem>
                :
                (props.noti.length < 1 ?
                  <DropdownItem tag="div" disabled >
                    <p className={'m-0 text-dark noti-para textsp-' + props.theme} >No New Notifications</p>
                  </DropdownItem>
                  :
                  null
                )
              )}
              <DropdownItem className='m-0' divider />
              <Button onClick={() => { axios.get(process.env.REACT_APP_DOMAIN + "/markall", { 'headers': { 'Authorization': 'Token ' + props.token } }); props.clear() }} className={"text-left noti noti-"} color='link' >
                <p className={'m-0 text-dark noti-para textsp-' + props.theme} >Mark all as read</p>
              </Button>
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav>
            <DropdownToggle className="pr-0" nav>
              <Media className="align-items-center">
                <Avatar alt="Remy Sharp" src={bgImage} className={"bgp-" + props.theme + " text-" + props.theme}>{namef}</Avatar>
                <Media className="ml-2 d-none d-lg-block">
                  <span className={"mb-0 text-sm font-weight-bold textb-" + props.theme}>
                    {props.fullname}
                  </span>
                </Media>
              </Media>
            </DropdownToggle>
            <DropdownMenu className={"dropdown-menu-arrow cardbg-" + props.theme} right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className={"text-overflow m-0 texts-" + props.theme}>{atype}</h6>
              </DropdownItem>
              <DropdownItem to={"/main/user-profile"} tag={Link}>
                <i className="ni ni-single-02" />
                <span className={"textsp-" + props.theme}>My profile</span>
              </DropdownItem>
              <DropdownItem to="/main/settings" tag={Link}>
                <i className="ni ni-settings-gear-65" />
                <span className={"textsp-" + props.theme}>Settings</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem href="/auth/logout">
                <i className="ni ni-button-power" />
                <span className={"textsp-" + props.theme}>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar className={"sbg-" + props.theme} isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className={"navbar-toggler texts-" + props.theme}
                  type="button"
                  onClick={toggleCollapse}
                >
                  <i className={"ni ni-fat-add texts-" + props.theme}></i>
                </button>
              </Col>
            </Row>
          </div>
          {/* Navigation */}
          <Nav navbar>{createLinks(routes)}</Nav>
          {/* Divider */}
          <hr className="my-3" />
          {/* Heading */}
          <h6 className="navbar-heading text-muted">Informational</h6>
          {/* Navigation */}
          <Nav className={"mb-md-3 sbg-" + props.theme} navbar>
            <NavItem>
              <NavLink className={'texts-'+props.theme} href="#">
                {/* <i className="ni ni-spaceshipx" /> */}
                Help
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink className={'texts-'+props.theme} href="#">
                <i className="ni ni-palettex" /> 
                Manual
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={'texts-'+props.theme} href="#">
                Complaints
              </NavLink>
            </NavItem>*/}
          </Nav>
        </Collapse>
      </Container>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
      </Snackbar>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export const mapStateToProps = state => {
  // console.log("this is the state", state);
  return {
    adminValue: state.switchRoutes.admin,
    userValue: state.switchRoutes.user,
    username: state.userName,
    fullname: state.tempUser,
    theme: state.theme,
    text: state.text,
    token: state.token,
    display: state.display,
  }
}

export default connect(mapStateToProps)(Sidebar);
